import React from "react";

const PrivacyPolicyPage = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-bold mb-6">Политика конфиденциальности</h1>

      <p className="mb-4">
        Настоящая политика конфиденциальности определяет порядок сбора, использования, хранения и
        раскрытия информации, получаемой от пользователей сайта metvnch.ru.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">1. Сбор персональной информации</h2>
      <p className="mb-4">
        Мы можем собирать личную информацию, такую как имя, номер телефона, адрес электронной почты
        и другую информацию, которую пользователь добровольно предоставляет при заполнении форм на
        сайте.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">2. Использование информации</h2>
      <p className="mb-4">
        Собранная информация используется исключительно для связи с пользователями, предоставления
        услуг, обработки заявок, а также для улучшения качества обслуживания.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">3. Защита данных</h2>
      <p className="mb-4">
        Мы принимаем все необходимые меры безопасности для защиты персональных данных от
        несанкционированного доступа, изменения, раскрытия или уничтожения.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">4. Передача третьим лицам</h2>
      <p className="mb-4">
        Мы не передаём личные данные пользователей третьим лицам, за исключением случаев,
        предусмотренных законодательством РФ.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">5. Согласие пользователя</h2>
      <p className="mb-4">
        Используя сайт metvnch.ru, пользователь выражает согласие с данной политикой
        конфиденциальности. В случае несогласия пользователь должен воздержаться от использования
        сайта.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">6. Изменения в политике</h2>
      <p className="mb-4">
        Мы оставляем за собой право изменять настоящую политику конфиденциальности в любое время.
        Изменения вступают в силу с момента публикации новой версии на сайте metvnch.ru.
      </p>
    </div>
  );
};

export default PrivacyPolicyPage;
